import React, { useState, useEffect } from 'react';
import PageTemplate from '../../Templates/PageTemplate';
import { Tab, Tabs } from "react-bootstrap";
import middleware from "../../Api/Middleware";
import '../../Main/Main.css';
import './EditCustomers.css';
import { useNavigate, useParams } from "react-router";
import NavbarIcon from "../user-solid.svg";
import Overview from './TabPages/Overview';
import AddressData from './TabPages/AddressData';
import OrdersTab from './TabPages/OrdersTab';
import Quotation from './TabPages/Quotation';
import Invoice from './TabPages/Invoice';
import Pin from './Icons/Pin.svg';
import Mail from './Icons/Mail.svg';
import Phone from './Icons/Telephone.svg';
import Cake from './Icons/Birthday-cake.svg';
import Loyalty from './TabPages/Loyalty';
import GeneralInfoTab from './TabPages/GeneralInfoTab';
import Notes from './TabPages/Notes';
import NoteModal from './CustomerModals/NoteModal';
import ConvertToBusiness from './CustomerModals/ConvertToBusiness';
import ToastError from '../../Toasts/ToastError';
import ToastSuccess from '../../Toasts/ToastSuccess';
import Cookies from 'universal-cookie';
import { BackButton, ButtonBlue } from '../../HouseStyle/Components/Buttons';
import { AddressKinds, getAddressKindLabel } from '../../Enums/addressKinds';
import { getCountryCode, getCountryName } from "../../../utils";

const EditCustomers = () => {
  const cookies = new Cookies();
  const { internal_id } = useParams();
  const [loading, setLoading] = useState(true);
  const [key, setKey] = useState(() => {
    return cookies.get('activeTabKey-' + internal_id) || "tab1";
  });
  const [activeTab, setActiveTab] = useState("Overzicht");
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [topNotes, setTopNotes] = useState([]);
  const [consumerData, setConsumerData] = useState({});
  const [consumerAddresses, setConsumerAddresses] = useState([]);
  const [businesses, setBusinesses] = useState([]);
  const [customerType, setCustomerType] = useState("");
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [showConvertModal, setShowConvertModal] = useState(false);
  const [selectedNoteData, setSelectedNoteData] = useState(null); // State for selected note
  const [dataUpdated, setDataUpdated] = useState(false);
  const typeOfCustomer = internal_id.charAt(0);
  const [pinnedNotes, setPinnedNotes] = useState([])
  const [consumerInfoUpdated, setConsumerInfoUpdated] = useState(false);
  const [isConverting, setIsConverting] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(null);
  
  const fetchAll = async () => {
    setLoading(true);
    try {
      const [ConsumerRes, TopNotesRes, ordersResponse, businessResponse, pinnedNotesResponse, consumerAddresses] = await Promise.all([
        middleware.get(`sp/customerHubOverview?internal_id=${internal_id}`),
        middleware.get(`sp/recentConsumerNotes?internal_id=${internal_id}`),
        middleware.get(`orders?internal_id=${internal_id}`),
        middleware.get(`businesses`),
        middleware.get(`sp/pinnedConsumerNotes?internal_id=${internal_id}`),
        middleware.get(`sp/consumeraddresses?internal_id=${internal_id}`)
      ]);
      setConsumerData(ConsumerRes.data[0]);
      setTopNotes(TopNotesRes.data);
      setConsumerAddresses(consumerAddresses.data);
      setData(ordersResponse.data.data);
      setBusinesses(businessResponse.data.data);
      setPinnedNotes(pinnedNotesResponse.data)
    } catch (error) {
      if (error.response.status == 401) {
        navigate("/login")
      }
      console.error('Error fetching data:', error);
    }
    setLoading(false);
  };
  const fetchConsumerData = async () => {
    const [consumerRes] = await Promise.all([
      middleware.get(`sp/customerHubOverview?internal_id=${internal_id}`),
    ]);
    setConsumerData(consumerRes.data[0]);
  }
  useEffect(() => {
    try {
      fetchAll();
      const initialTab = tabs.find((tab) => tab.eventKey === key);
      if (initialTab) {
        setActiveTab(initialTab.navbarTitle);
      }
    } catch (error) {
      console.warn(error);
    }
  }, []);

  useEffect(() => {
    fetchConsumerData();
    setConsumerInfoUpdated(false);
  }, [consumerInfoUpdated])

  useEffect(() => {
    if (dataUpdated) {

      fetchAll();
      setDataUpdated(false); // Reset the flag after fetching the data
    }
  }, [dataUpdated]);

  const closeModalNote = () => setShowNoteModal(false);
  const closeModalConvert = () => setShowConvertModal(false);

  const ConvertToBusinessModal = () => {
    setShowConvertModal(true)
  };

  const handleConvertConfirmed = async (info) => {
  setShowConvertModal(false);
  setIsConverting(true);
  setLoadingMessage("Bezig met converteren...");

  try {
    const res = await middleware.post(
      `convertToBusiness?internal_id=${internal_id}`,
      {
        company_name: info.companyName,
        cocnumber: info.companyNumber,
        vatnumber: info.vatNumber,
        country_code_id: info.countryCodeId
      }
    );
    ToastSuccess("Klaar met converteren");
    setLoadingMessage("Klaar met converteren");
    await new Promise(resolve => setTimeout(resolve, 1000));
    navigate(`../klanten/bewerken/${res.data.data.business.internal_id}`);
    fetchAll();
  } catch (error) {
      ToastError("Er is een fout opgetreden bij het converteren");
  } 
    setIsConverting(false); 
};

  const navigateTabs = (e) => {

    const selectedTab = tabs.find(tab => tab.eventKey === e);
    if (selectedTab) {
      setKey(e);
      setActiveTab(selectedTab.navbarTitle);
      sessionStorage.setItem('activeTabKey-' + internal_id, selectedTab.eventKey);
    } else {
      console.error('Tab not found');
    }
  };

  const splitString = (str) => {
    return str ? str.split(',').map(item => item.trim()) : [];
  };

  const tabs = [
    {
      eventKey: "tab1",
      title: "Overzicht",
      navbarTitle: "Overzicht",
      content: (activeTab == "Overzicht" && <Overview NavigateTab={(e) => navigateTabs(e)} consumerData={consumerData} consumerAddress={consumerAddresses} />),
    },
    {
      eventKey: "tab2",
      title: "Algemene gegevens",
      navbarTitle: "Algemene gegevens",
      content: (activeTab == "Algemene gegevens" && <GeneralInfoTab consumerData={consumerData} typeCustomer={typeOfCustomer} setConsumerInfoUpdated={setConsumerInfoUpdated} setDataUpdated={setDataUpdated} dataUpdated={dataUpdated} />),
    },
    {
      eventKey: "tab3",
      title: "Adresgegevens",
      navbarTitle: "Adresgegevens",
      content: (activeTab == "Adresgegevens" && <AddressData consumerData={consumerData} consumerAddresses={consumerAddresses} setDataUpdated={setDataUpdated} />),
    },
    {
      eventKey: "tab4",
      title: "Bestellingen",
      navbarTitle: "Bestellingen",
      content: (activeTab == "Bestellingen" && <OrdersTab data={data} />),
    },
    // {
    //   eventKey: "tab5",
    //   title: "Offertes",
    //   navbarTitle: "Offertes",
    //   content: (activeTab == "Offertes" && <Quotation data={data} />),
    // },
    {
      eventKey: "tab6",
      title: "Facturen",
      navbarTitle: "Facturen",
      content: (activeTab == "Facturen" && <Invoice data={data} />),
    },
    {
      eventKey: "tab7",
      title: "Loyaliteit",
      navbarTitle: "Loyaliteit",
      content: (activeTab == "Loyaliteit" && <Loyalty typeCustomer={typeOfCustomer} consumerData={consumerData} />),
    },
    {
      eventKey: "tab8",
      title: "Notities",
      navbarTitle: "Notities",
      content: (activeTab == "Notities" && <Notes dataUpdated={dataUpdated} setDataUpdated={setDataUpdated} typeCustomer={typeOfCustomer} />),
    },
  ];

  return (
    <PageTemplate navbarTitle={"Klant informatie"} pageIsLoading={isConverting || loading} loadingTitle={loadingMessage || "even geduld"}>
      <NoteModal openNote={showNoteModal} data={selectedNoteData} closeNote={closeModalNote} />
      <ConvertToBusiness openConvertToBusiness={showConvertModal} closeConvertToBusiness={closeModalConvert} onConvertConfirmed={handleConvertConfirmed} />
      <div className='parentBoxSize'>
        <BackButton text={'Terug'} onClickFunction={() => navigate('/klanten')} />
        <div className='col-12 d-flex flex-column flex-xxl-row justify-content-between responsiveEditCustomers'>
          {activeTab === "Overzicht" ? (
            <div className='col-12 col-xxl-8'>
              <div className="tabContainer whiteBox px-4 tabsOverviewPadding col-12">
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={(k) => {
                    setKey(k);
                    const tab = tabs.find((t) => t.eventKey === k);
                    setActiveTab(tab.navbarTitle);
                    cookies.remove('activeTabKey-' + internal_id);
                    cookies.set('activeTabKey-' + internal_id, tab.eventKey, { maxAge: 5400 });
                  }}
                >
                  {tabs.map((tab) => (
                    <Tab
                      key={tab.eventKey}
                      eventKey={tab.eventKey}
                      title={
                        <span
                          className={`tab-title ${key === tab.eventKey ? "active" : ""} fw-semibold`}
                        >
                          {tab.title}
                        </span>
                      }
                      disabled={tab.disabled}
                    >
                      {activeTab !== "Overzicht" ? (
                        <div key={tab.eventKey} className="tabContent">{tab.content}</div>
                      ) : (
                        ""
                      )}
                    </Tab>
                  ))}
                </Tabs>
              </div>
              {activeTab === "Overzicht" &&
                tabs.map((tab) => (
                  tab.title === "Overzicht" && (
                    <div key={tab.eventKey} className='mt-4'>
                      <div className="tabContent fitcontentHeight">{tab.content}</div>
                    </div>
                  )
                ))
              }
            </div>
          ) : (
            <div className="tabContainer whiteBox col-12 col-xxl-8 px-4 fitcontentHeight mb-5 mb-xxl-0">
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => {
                  setKey(k);
                  const tab = tabs.find((t) => t.eventKey === k);
                  setActiveTab(tab.navbarTitle);
                  cookies.remove('activeTabKey-' + internal_id);
                  cookies.set('activeTabKey-' + internal_id, tab.eventKey, { maxAge: 5400 });
                }}
              >
                {tabs.map((tab) => (
                  <Tab
                    key={tab.eventKey}
                    eventKey={tab.eventKey}
                    title={
                      <span className={`tab-title ${key === tab.eventKey ? "active" : ""} fw-semibold`}>
                        {tab.title}
                      </span>
                    }
                    disabled={tab.disabled}
                  >
                    <div key={tab.eventKey} className="tabContent h-100">{tab.content}</div>
                  </Tab>
                ))}
              </Tabs>
            </div>
          )}
          {activeTab === "Overzicht" ? (
            <div className='convertToAndNotes'>
              <div className='convertToBoxOverview'>
                {typeOfCustomer === "C" &&
                  <ButtonBlue
                    onClickFunction={ConvertToBusinessModal}
                    text={"Omzetten naar bedrijf"} />
                }
                {/* <button className={`btn convertToBusinessButton ${typeOfCustomer === "C" ? "" : "d-none"}`} onClick={() => ConvertToBusinessModal()}>Omzetten naar bedrijf</button> */}
              </div>
              <div className={`whiteBox py-4 px-5 latestNotesQuotation mb-5`}>
                <div className={pinnedNotes.length ? '' : 'd-none'}>
                  <h5 className='fw-bold mb-3'>Vastgemaakte notities</h5>
                  {pinnedNotes?.map((note, index) => (
                    <div key={index}>
                      <h6 className='darkBlueLinkText text-nowrap mb-0'>
                        {note.created_date} &#x2022; {note.user}
                      </h6>
                      <span style={{ fontSize: '14px' }} className='darkBlueLinkText text-nowrap'>
                        {note.created_time}
                      </span>
                      <p
                        className='noteTitle mt-1 fw-semibold cursorPointer'
                        onClick={() => {
                          setSelectedNoteData(note); // Set the selected note data
                          setShowNoteModal(true); // Show the modal
                        }}
                      >
                        {note.note_title || ''}
                      </p>
                      {note.note.length > 250 ? (
                        <p className="text-break" style={{ maxWidth: "400px" }}>
                          {note.note.slice(0, 250)}...
                        </p>
                      ) : (
                        <p className="text-break" style={{ maxWidth: "400px" }}>{note.note}</p>
                      )}
                      {index < pinnedNotes.length - 1 && <hr className='noteDivider' />}
                    </div>
                  ))}
                  <hr className='noteDivider border-3' />
                </div>
                <h5 className='fw-bold mb-3'>Laatste notities</h5>
                {topNotes?.map((note, index) => (
                  <div key={index}>
                    <h6 className='darkBlueLinkText text-break mb-0'>{note.created_date} &#x2022; {note.user}  </h6>
                    <span style={{ fontSize: '14px' }} className='darkBlueLinkText text-nowrap'>
                      {note.created_time}
                    </span>
                    <p
                      className='noteTitle fw-semibold cursorPointer text-break'
                      onClick={() => {
                        setSelectedNoteData(note); // Set the selected note data
                        setShowNoteModal(true); // Show the modal
                      }}
                    >
                      {note.note_title || ''}
                    </p>
                    {note.note.length > 250 ? (
                      <p className="text-break" style={{ maxWidth: "400px" }}>
                        {note.note.slice(0, 250)}...
                      </p>
                    ) : (
                      <p className="text-break" style={{ maxWidth: "400px" }}>{note.note}</p>
                    )}
                    {index < topNotes.length - 1 && <hr className='noteDivider' />}
                  </div>
                ))}
                <p className='fw-semibold'>{topNotes?.length <= 0 ? "Geen notities gevonden" : ""}</p>
              </div>
            </div>
          ) : (
            <>
              {activeTab !== "Overzicht" ? (
                <div className='col-2 customerInfoBox fitcontentHeight d-flex flex-column'>
                  {loading ?
                    <div className='col-12 py-4 px-5 customerInfoBoxWithNotes whiteBox fitcontentHeight' style={{ paddingLeft: "25px" }}>
                      <h4 className="m-4 loader"></h4>
                    </div>
                    :
                    <div className='col-12 py-4 px-5 customerInfoBoxWithNotes whiteBox fitcontentHeight' style={{ paddingLeft: "25px" }}>
                      <div className='mb-4'>
                        <h3 className='mb-3 text-nowrap'>Overzicht {consumerData.relation}</h3>
                        <h5>{consumerData.company_name ?? (consumerData.first_name + ' ' + consumerData.last_name)}</h5>
                      </div>
                      <div className='d-flex flex-column justify-content-between fitcontentHeight mb-2'>
                        {consumerAddresses?.filter(e => e.address_kind != null).map((map, index) => {
                          if (map.address_kind== AddressKinds.DELIVERY_ADDRESS) {
                            return (
                              <div key={index}>
                                {getAddressKindLabel(AddressKinds.DELIVERY_ADDRESS)}
                                <div className='d-flex flex-row my-3'>
                                  <img className='text-white rounded-2 infoIcons' src={Pin} />
                                  <div className='textInfoCustomer d-flex flex-column align-self-center fw-medium'>
                                    <div className='text-nowrap'>
                                      {map.street}
                                    </div>
                                    <div className='text-nowrap'>
                                      {map.location}
                                    </div>
                                    <div className='text-nowrap'>
                                      {getCountryName(getCountryCode(map.country, 'en'))}
                                    </div>
                                  </div>
                                </div>
                              </div>)
                          } else if (map.address_kind== AddressKinds.INVOICE_ADDRESS) {
                            return (
                              <div key={index}>
                                {getAddressKindLabel(AddressKinds.INVOICE_ADDRESS)}
                                <div className='d-flex flex-row my-3'>
                                  <img className='text-white rounded-2 infoIcons' src={Pin} />
                                  <div className='textInfoCustomer d-flex flex-column align-self-center fw-medium'>
                                    <div className='text-nowrap'>
                                      {map.street}
                                    </div>
                                    <div className='text-nowrap'>
                                      {map.location}
                                    </div>
                                    <div className='text-nowrap'>
                                      {getCountryName(getCountryCode(map.country, 'en'))}
                                    </div>
                                  </div>
                                </div>
                              </div>)
                          } else if (map.address_kind == AddressKinds.DELIVERY_AND_INVOICE_ADDRESS) {
                            return (
                              <div key={index}>
                                {getAddressKindLabel(AddressKinds.DELIVERY_AND_INVOICE_ADDRESS)}
                                <div className='d-flex flex-row my-3'>
                                  <img className='text-white rounded-2 infoIcons' src={Pin} />
                                  <div className='textInfoCustomer d-flex flex-column align-self-center fw-medium'>
                                    <div className='text-nowrap'>
                                      {map.street}
                                    </div>
                                    <div className='text-nowrap'>
                                      {map.location}
                                    </div>
                                    <div className='text-nowrap'>
                                      {getCountryName(getCountryCode(map.country, 'en'))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                        })}
                        {consumerData.phone_numbers &&
                          <div className='d-flex flex-row my-3'>
                            <img className='text-white rounded-2 infoIcons' src={Phone} />
                            <div className='d-flex flex-column justify-content-center'>
                              {splitString(consumerData.phone_numbers).map((phone_number, index) => (
                                <div className='fw-medium mb-1' key={index}>{phone_number}</div>
                              ))}
                            </div>
                          </div>}
                        {consumerData.emails &&

                          <div className='d-flex flex-row my-3'>
                            <img className='text-white rounded-2 infoIcons' src={Mail} />
                            <div className='d-flex flex-column justify-content-center'>
                              {splitString(consumerData.emails).map((email, index) => (
                                <div className='fw-medium mb-1' key={index}>{email}</div>
                              ))}
                            </div>
                          </div>
                        }
                        {consumerData.birthday &&
                          <div className='d-flex flex-row my-3'>
                            <img className='text-white rounded-2 infoIcons' src={Cake} />
                            <p className='textInfoCustomer d-flex align-self-center fw-semibold text-nowrap'>{consumerData.birthday} ({consumerData.age})</p>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  {loading ?
                    <div className='col-2 py-4 px-5 mt-4 customerInfoBox whiteBox fitcontentHeight minFitContent' style={{ paddingLeft: "25px" }}>
                      <h4 className="m-4 loader"></h4>
                    </div>
                    :
                    <div className={`mt-4 whiteBox py-4 px-5 latestNotesQuotation mb-5`}>
                      <div className={pinnedNotes.length ? '' : 'd-none'}>
                        <h5 className='fw-bold mb-3'>Vastgemaakte notities</h5>
                        {pinnedNotes?.map((note, index) => (
                          <div key={index}>
                            <h6 className='darkBlueLinkText text-nowrap mb-0'>
                              {note.created_date} &#x2022; {note.user}
                            </h6>
                            <span style={{ fontSize: '14px' }} className='darkBlueLinkText text-nowrap'>
                              {note.created_time}
                            </span>
                            <p
                              className='noteTitle mt-1 fw-semibold cursorPointer'
                              onClick={() => {
                                setSelectedNoteData(note); // Set the selected note data
                                setShowNoteModal(true); // Show the modal
                              }}
                            >
                              {note.note_title || ''}
                            </p>                      {note.note.length > 250 ? (
                              <p className="text-break" style={{ maxWidth: "400px" }}>
                                {note.note.slice(0, 250)}...
                              </p>
                            ) : (
                              <p className="text-break" style={{ maxWidth: "400px" }}>{note.note}</p>
                            )}
                            {index < pinnedNotes.length - 1 && <hr className='noteDivider' />}
                          </div>
                        ))}
                        <hr className='noteDivider border-3' />
                      </div>
                      <h5 className='fw-bold mb-3'>Laatste notities</h5>
                      {topNotes?.map((note, index) => (
                        <div key={index}>
                          <h6 className='darkBlueLinkText text-break mb-0'>{note.created_date} &#x2022; {note.user}  </h6>
                          <span style={{ fontSize: '14px' }} className='darkBlueLinkText text-break'>
                            {note.created_time}
                          </span>
                          <p
                            className='noteTitle fw-semibold cursorPointer text-break'
                            onClick={() => {
                              setSelectedNoteData(note); // Set the selected note data
                              setShowNoteModal(true); // Show the modal
                            }}
                          >
                            {note.note_title || ''}
                          </p>                    {note.note.length > 250 ? (
                            <p className="text-break" style={{ maxWidth: "400px" }}>
                              {note.note.slice(0, 250)}...
                            </p>
                          ) : (
                            <p className="text-break" style={{ maxWidth: "400px" }}>{note.note}</p>
                          )}
                          {index < topNotes.length - 1 && <hr className='noteDivider' />}
                        </div>
                      ))}
                      <p className='fw-semibold'>{topNotes?.length <= 0 ? "Geen notities gevonden" : ""}</p>
                    </div>
                  }
                </div>
              ) : (
                <>
                  {loading ?
                    <div className='col-2 py-4 px-5 customerInfoBox whiteBox fitcontentHeight' style={{ paddingLeft: "25px" }}>
                      <h4 className="m-4 loader"></h4>
                    </div>
                    :
                    <div className='col-3 py-4 px-5 customerInfoBox whiteBox fitcontentHeight' style={{ paddingLeft: "25px" }}>
                      <div className='mb-4'>
                        <h3 className='mb-3 text-nowrap'>Overzicht {consumerData.relation}</h3>
                        <h5>{consumerData.company_name ?? (consumerData.first_name + ' ' + consumerData.last_name)}</h5>
                      </div>
                      <div className='d-flex flex-row flex-xxl-column justify-content-between fitcontentHeight mb-2'>
                        {consumerAddresses?.filter(e => e.address_kind != null).map((map, index) => {
                          if ([0, 2].includes(map.address_kind)) {
                            return (
                              <div key={index}>
                                Bezorgadres
                                <div className='d-flex flex-row my-3'>
                                  <img className='text-white rounded-2 infoIcons' src={Pin} />
                                  <div className='textInfoCustomer d-flex flex-column align-self-center fw-medium'>
                                    <div className='text-nowrap'>
                                      {map.street}
                                    </div>
                                    <div className='text-nowrap'>
                                      {map.location}
                                    </div>
                                    <div className='text-nowrap'>
                                      {getCountryName(getCountryCode(map.country, 'en'))}
                                    </div>
                                  </div>
                                </div>
                              </div>)
                          } else if ([1, 3].includes(map.address_kind)) {
                            return (
                              <div key={index}>
                                Factuuradres
                                <div className='d-flex flex-row my-3'>
                                  <img className='text-white rounded-2 infoIcons' src={Pin} />
                                  <div className='textInfoCustomer d-flex flex-column align-self-center fw-medium'>
                                    <div className='text-nowrap'>
                                      {map.street}
                                    </div>
                                    <div className='text-nowrap'>
                                      {map.location}
                                    </div>
                                    <div className='text-nowrap'>
                                      {getCountryName(getCountryCode(map.country, 'en'))}
                                    </div>
                                  </div>
                                </div>
                              </div>)
                          } else if ([4, 5].includes(map.address_kind)) {
                            return (
                              <div key={index}>
                                Factuuradres en Bezorgadres
                                <div className='d-flex flex-row my-3'>
                                  <img className='text-white rounded-2 infoIcons' src={Pin} />
                                  <div className='textInfoCustomer d-flex flex-column align-self-center fw-medium'>
                                    <div className='text-nowrap'>
                                      {map.street}
                                    </div>
                                    <div className='text-nowrap'>
                                      {map.location}
                                    </div>
                                    <div className='text-nowrap'>
                                      {getCountryName(getCountryCode(map.country, 'en'))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                        })}
                        {consumerData.phone_numbers &&
                          <div className='d-flex flex-row my-3'>
                            <img className='text-white rounded-2 infoIcons' src={Phone} />
                            <div className='d-flex flex-column justify-content-center'>
                              {splitString(consumerData.phone_numbers).map((phone_number, index) => (
                                <div className='fw-medium mb-1' key={index}>{phone_number}</div>
                              ))}
                            </div>
                          </div>
                        }
                        {consumerData.emails &&
                          <div className='d-flex flex-row my-3'>
                            <img className='text-white rounded-2 infoIcons' src={Mail} />
                            <div className='d-flex flex-column justify-content-center'>
                              {splitString(consumerData.emails).map((email, index) => (
                                <div className='fw-medium mb-1' key={index}>{email}</div>
                              ))}
                            </div>
                          </div>}
                        {consumerData.birthday && <>
                          <div className='d-flex flex-row my-3'>
                            <img className='text-white rounded-2 infoIcons' src={Cake} />
                            <p className='textInfoCustomer d-flex align-self-center fw-semibold text-nowrap'>{consumerData.birthday} ({consumerData.age})</p>
                          </div>
                        </>}
                      </div>
                    </div>
                  }

                </>
              )}
            </>
          )}
        </div>
      </div>
    </PageTemplate>
  );
}

export default EditCustomers;
